import { render, staticRenderFns } from "./DeleteBucketDialog.vue?vue&type=template&id=16870852"
import script from "./DeleteBucketDialog.vue?vue&type=script&lang=js"
export * from "./DeleteBucketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports